module.exports = __webpack_public_path__ + "media/bootstrap-icons/share-5a50946f.svg";